module.exports = __webpack_public_path__ + "img/aiSubtitles_embed.ad760efa.svg";